import Service from './Service';

class AnexoService extends Service {
  async download (id, filename) {
    let result = await this.getAnexoApi().download(id, filename);
    return result;
  }

  async delete (id, filename) {
    let result = await this.getAnexoApi().delete(id, filename);
    return result;
  }

  async upload (data) {
    let result = await this.getAnexoApi().upload(data);
    return result;
  }
}

export default AnexoService;
